import { CancellationType } from '../constants/cancellation';
import type { ICancellationType } from '../types/cancellation.types';

export const getTranslationKeyFromCancellationType = (
  cancellationType: ICancellationType
): string => {
  let translationKey = '';
  switch (cancellationType) {
    case CancellationType.CARE_INITIATED:
      translationKey = 'careInitiated';
      break;
    case CancellationType.CONTENT_TOU_VIOLATION_GENERIC:
      translationKey = 'termsOfUseViolation';
      break;
    case CancellationType.COPYRIGHT_CONTENT:
      translationKey = `copyrightViolation`;
      break;
    case CancellationType.FEEDBACK_RESOLUTION:
      translationKey = `embroideryAutoCancel`;
      break;
    case CancellationType.INAPPROPRIATE_CONTENT:
      translationKey = `contentViolation`;
      break;
    case CancellationType.LOW_INVENTORY:
      translationKey = `lowInventory`;
      break;
    case CancellationType.PAYMENT_FAILURE:
    case CancellationType.PAYMENT_FRAUD_DECLINED:
    case CancellationType.PAYMENT_PAST_DUE:
      translationKey = `paymentIssue`;
      break;
    case CancellationType.SHOPPER_INITIATED:
      translationKey = `customerInitiated`;
      break;
    default:
      translationKey = '';
  }
  return translationKey;
};
